import axios from "axios";
import authentication from "@/authentication";

export default {
  async loadPackages() {
    await authentication.isAuthenticated();
    return axios
      .get(
        `${process.env.VUE_APP_API_PACKAGE_SERVICE_BASE}/GetAlliancePackageDetail`,
        {
          headers: { Authorization: "Bearer " + authentication.getToken() }
        }
      )
      .then(response => {
        return JSON.parse(response.data);
      });
  },
  async loadClients() {
    await authentication.isAuthenticated();
    return axios
      .get(
        process.env.VUE_APP_API_CLIENT_SERVICE_BASE + "/GetAllianceLocations",
        {
          headers: { Authorization: "Bearer " + authentication.getToken() }
        }
      )
      .then(response => {
        return response.data;
      });
  },
  async getExcelDocument(filters) {
    await authentication.isAuthenticated();
    return axios
      .post(
        `${process.env.VUE_APP_API_PACKAGE_SERVICE_BASE}/GetExcelDocument`,
        filters,
        {
          headers: {
            Authorization: `Bearer ${authentication.getToken()}`
          }
        }
      )
      .then(response => {
        return response.data;
      });
  }
};
